import { cn } from '@/utils/cn';
import { initialsFromName } from '@/lib/initials';

export type AvatarSize = 28 | 36 | 40 | 48 | 56 | 72;

export function Avatar({
  name,
  size = 36,
  className,
}: {
  name: string;
  size?: AvatarSize;
  className?: string;
}) {
  const px = `${size}px`;
  const type =
    size >= 72 ? 'text-[24px] leading-8' : size >= 48 ? 'text-[16px] leading-6' : 'text-[13px] leading-5';
  return (
    <span
      aria-hidden="true"
      className={cn(
        'inline-flex shrink-0 items-center justify-center rounded-full bg-ds-teal-tint font-semibold text-ds-teal',
        type,
        className,
      )}
      style={{ width: px, height: px }}
    >
      {initialsFromName(name)}
    </span>
  );
}
